//
//
//
//
//
//

export default {
  name: 'Doc',
  methods: {
    click: function click() {
      window.open('https://doc.el-admin.xin/guide/', '_blank');
    }
  }
};